import type { StrapiLocale } from "@nuxtjs/strapi/dist/runtime/types";
import type { Faq_Plain } from "@webamboos/admin";

export function useFaqs() {
  const { localeProperties } = useI18n();
  const { find } = useStrapi();

  const fetch = async () => {
    const { data } = await find("faqs", {
      locale: localeProperties.value.code as StrapiLocale,
      sort: "sort_id:asc",
    });

    const items = data as unknown as Faq_Plain[];
    return items;
  };

  return {
    fetch,
  };
}
